import { Slider, styled } from '@mui/material';

const boxShadow = '0 2px 4px rgba(0,0,0,0.15)';

export const StyledSlider = styled(Slider)(({ theme }) => ({
  color: theme.palette.info.main,
  height: 4,
  padding: '15px 0',
  width: 'calc(100% - 24px)',
  margin: '0 8px',
  '& .MuiSlider-thumb': {
    height: 14,
    width: 14,
    backgroundColor: theme.palette.info.main,
    boxShadow: boxShadow,
    '&:focus, &:hover, &.Mui-active': {
      boxShadow: '0 2px 6px rgba(0,0,0,0.25)',
      '@media (hover: none)': {
        boxShadow: boxShadow,
      },
    },
  },

  '& .MuiSlider-valueLabel': {
    fontSize: 16,
    lineHeight: '20px',
    fontWeight: 600,
    top: 0,
    backgroundColor: 'unset',

    '& *': {
      background: 'transparent',
      color: theme.palette.info.main,
    },
  },
  '& .MuiSlider-track': {
    backgroundColor: theme.palette.info.main,
    borderColor: theme.palette.info.main,
  },
  '& .MuiSlider-rail': {
    opacity: 1,
    backgroundColor: theme.palette.primary.grey,
  },

  [theme.breakpoints.down('desktop')]: {
    '& .MuiSlider-valueLabel': {
      fontSize: 16,
    },
  },
}));
